

















































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import Label from '@/components/common/elements/Label.vue';
import InputNoVModel from '@/components/common/elements/InputNoVModel.vue';
import Dialog from '@/components/common/modules/Dialog.vue';
import DialogMasterSelectTable from '@/components/common/modules/DialogMasterSelectTable.vue';
@Component({
  components: { InputNoVModel, Label, Dialog, DialogMasterSelectTable }
})
export default class MasterSelectSetControl extends Vue {
  // 要素名
  @Prop({ default: () => [] })
  private name!: Array<any>;

  // テーブルに表示するカラム配列
  @Prop({ default: () => [] })
  private columns!: Array<any>;

  // テーブルに表示するデータ配列
  @Prop({ default: () => [] })
  private body!: Array<any>;

  // テーブルから取得するデータ配列
  @Prop({ default: () => [] })
  private outPutData!: Array<any>;
  // 初期値
  @Prop({ default: '' })
  private value?: string;
  // ダイヤログ表示のタイトル
  @Prop({ default: '' })
  private dialogTitle?: string;
  // rulesの付与
  @Prop({ default: '' })
  private rules?: string;

  // ダイアログの表示制御値
  private dialogStatus = false;
  // 取得ボタンの表示・非表示
  @Prop({ default: true })
  private isBtnVisible?: boolean;
  // 編集モード判定制御値
  @Prop({ default: true })
  private isEditMode?: boolean;

  /**
   * 初期値の設定
   */
  mounted() {
    if (this.value) {
      const findData = this.body.find((v) => String(v.id) === String(this.value));
      const setting: Array<any> = JSON.parse(JSON.stringify(this.outPutData));
      if (findData)
        this.outPutData.splice(0);
      setting.forEach((field) => {
        if (findData[field.name]) {
          this.outPutData.push({...field, ...{value: findData[field.name]}})
        }
      });
    }
  }
  /**
   * 親コンポーネントに入力値を通知する
   * @module inputOperation
   * @return data - 名前と入力値
   */
  @Emit('inputOperation')
  public inputOperation(data: any) {
    if (data.value) {
      const findData = this.body.find((v) => String(v.id) === String(data.value));
      const setting: Array<any> = JSON.parse(JSON.stringify(this.outPutData));
      this.outPutData.splice(0);
      setting.forEach((field) => {
        if (findData !== undefined && findData[field.name]) {
          this.outPutData.push({...field, ...{value: findData[field.name]}});
        } else {
          this.outPutData.push({...field, ...{value: ''}});
        }
      });
    }
    return data;
  }

  /**
   * 親コンポーネントに入力値を通知する
   * @module inputOperationRelay
   * @return data - 名前と入力値
   */
  @Emit('catchTableDataRelay')
  public catchTableDataRelay(data: any) {
    const selectData = data.selectData;
    this.outPutData.forEach((field, index) => {
      if (field.name in selectData) {
        this.outPutData[index].value = selectData[field.name];
      }
    });
    // 親コンポーネントへ通知
    this.inputOperation({ name: this.name, value: selectData.id });
    this.dialogStatus = false;
    return data.selectData;
  }

  /**
   * ダイアログを使用する場合のイベント取得処理
   * 子コンポーネントからEmitされる値をコンソールに出力
   * （値が渡されるか確認用）
   * @module changeDialogStatus
   * @param {Object} e - 子コンポーネントより渡される値
   * @return {void} - コンソールに出力
   */
  private changeDialogStatus(): void {
    this.dialogStatus = false;
  }
}
